import React from 'react';

import classes from './emptyField.module.scss';

export const EmptyField = (props) => {
  const { title, children } = props;

  return <div className={classes.EmptyField}>{title ?? children}</div>;
};
